import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmArrowRight = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-llm-arrow-right",
    width: "1em",
    height: "1em",
    "data-icon": "icon-llm-arrow-right",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      clipRule: "evenodd",
      d: "m23.7 11.3-9.7-9.7-1.4 1.4 8 8h-20.6v2h20.6l-8 8 1.4 1.4 9.7-9.7c.4-.4.4-1-0-1.4z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  }));
});
IconLlmArrowRight.displayName = 'IconLlmArrowRight';

export { IconLlmArrowRight };
//# sourceMappingURL=llm-arrow-right.js.map
